<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <h4 class="text-center text-muted font-weight-light mt-4">
                    Para conocer tu cotización, déjanos tu nombre, correo
                    electrónico y teléfono
                </h4>
                <form class="mt-4 mb-2" @submit.prevent="sendCotizacion">
                    <b-form-group label="Nombre">
                        <b-form-input
                            type="text"
                            placeholder="Ingrese su nombre"
                            v-model.trim="$v.cliente.nombre.$model"
                            :class="{ 'is-invalid': $v.cliente.nombre.$error }"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            <span v-if="!$v.cliente.nombre.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                    </b-form-group>
                    <b-form-group label="Apellido">
                        <b-form-input
                            type="text"
                            placeholder="Ingrese su apellido"
                            v-model.trim="$v.cliente.apellido.$model"
                            :class="{ 'is-invalid': $v.cliente.apellido.$error }"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            <span v-if="!$v.cliente.apellido.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                    </b-form-group>
                    <b-form-group label="Correo electrónico">
                        <b-form-input
                            type="text"
                            placeholder="Ingrese su correo electrónico"
                            v-model.trim="$v.cliente.email.$model"
                            :class="{ 'is-invalid': $v.cliente.email.$error }"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            <span v-if="!$v.cliente.email.$required"
                                >Este campo es requerido</span
                            >
                            <br />
                            <span v-if="!$v.cliente.email.$email"
                                >Formato de correo electrónico inválido</span
                            >
                        </div>
                    </b-form-group>
                    <b-form-group label="Teléfono">
                        <b-form-input
                            type="text"
                            placeholder="Ingrese su número de teléfono"
                            maxlength="10"
                            v-model.number.lazy="$v.cliente.celular.$model"
                            :class="{ 'is-invalid': $v.cliente.celular.$error }"
                        ></b-form-input>
                        <div class="invalid-feedback">
                            <span v-if="!$v.cliente.celular.$required"
                                >Este campo es requerido</span
                            >
                            <br />
                            <span v-if="!$v.cliente.celular.$numeric"
                                >Formato de teléfono inválido</span
                            >
                        </div>
                    </b-form-group>
                    <b-form-group label="Ubicación">
                        <vue-autosuggest
                            v-model.trim="$v.cliente.ubicacion_name.$model"
                            :suggestions="ubicacionFiltered"
                            :input-props="{
                                id: 'autosuggest__input',
                                placeholder: 'Seleccione su ubicación',
                                class: 'form-control'
                            }"
                            @input="onInputUbicacion"
                            :get-suggestion-value="getUbicacionValue"
                            @selected="selectUbicacion"
                            :class="{
                                'is-invalid': $v.cliente.ubicacion_name.$error
                            }"
                        >
                            <template slot-scope="{ suggestion }">
                                {{ suggestion.item.ciudad }} -
                                {{ suggestion.item.depto }}
                            </template>
                        </vue-autosuggest>
                        <div class="invalid-feedback">
                            <span v-if="!$v.cliente.ubicacion_name.$required"
                                >Este campo es requerido</span
                            >
                        </div>
                        <!-- <b-form-input
                            type="text"
                            placeholder="Seleccione su ubicación"
                            v-model="cliente.ubicacion_name"
                        ></b-form-input> -->
                    </b-form-group>
                    <div class="row justify-content-center">
                        <div class="col-md-12">                           
                            <label>
                                <i class="fa fa-check-square" aria-hidden="true"></i>
                                Al solicitar la cotización estás aceptando
                                nuestra
                                <a
                                    href="https://redautos.com/politica_tratamiento_datos_personales"
                                    target="_blank"
                                >
                                    Política de privacidad de datos personales
                                </a>
                            </label>
                        </div>
                        <div class="col-md-12">
                            <b-button
                                :disabled="onLoadForm"
                                @click="sendCotizacion"
                                block
                                type="submit"
                            >
                                <clip-loader
                                    :class="{ 'd-none': !onLoadForm }"
                                    style="display: inline;"
                                    color="#fff"
                                    size="15px"
                                ></clip-loader>
                                Solicitar cotización
                            </b-button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { VueAutosuggest } from "vue-autosuggest";
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
    computed: {
        selectionData() {
            return this.$store.state.vender.selection_data;
        },
        ...mapFields("vender", [
            "velocimetro",
            "pendiente",
            "cotizacion",
            "asistente_step",
            "titulo_span"
        ])
    },
    components: {
        VueAutosuggest
    },
    data() {
        return {
            ubicacionFiltered: [],
            onLoadForm: false,
            errorsMessage: false,
            cliente: {
                nombre: "",
                apellido: "",
                celular: "",
                whatsapp: "",
                whatsapp_checked: false,
                email: "",
                ubicacion_id: "",
                ubicacion_name: "",
                clientes: [],
                fillCliente: false
            }
        };
    },
    validations: {
        cliente: {
            nombre: {
                required
            },
            apellido: {
                required
            },
            email: {
                required,
                email
            },
            celular: {
                required,
                numeric
            },
            ubicacion_name: {
                required
            }
        }
    },
    methods: {
        onInputUbicacion(text) {
            if (text === "" || text === undefined) {
                return;
            }
            axios
                .get("/ajax/search_ubicacion", {
                    params: {
                        search: text
                    }
                })
                .then(response => {
                    this.ubicacionFiltered = [
                        {
                            data: response.data.ciudades
                        }
                    ];
                });
        },
        getUbicacionValue(suggestion) {
            return suggestion.item.ciudad + " - " + suggestion.item.depto;
        },
        selectUbicacion(suggestion) {
            this.ubicacion_id = suggestion.item._id;
            this.cliente.ubicacion_name =
                suggestion.item.ciudad + " - " + suggestion.item.depto;
        },
        sendCotizacion() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return (this.submitStatus = "False");
            } else {
                this.onLoadForm = true;
                var vehiculo = {
                    id_marca: this.selectionData.marca_id,
                    id_modelo: this.selectionData.modelo,
                    id_linea: this.selectionData.linea_id,
                    id_version: this.selectionData.version_id,
                    id_modelorel: this.selectionData.modelorel_id,
                    color_primario: this.selectionData.color,
                    kilometraje: this.selectionData.kilometraje,
                    canal: "",
                    origen: ""
                };
                var data = {
                    vehiculo: vehiculo,
                    cliente: this.cliente
                };

                data = {
                    ...data,
                    vehiculo: { ...data.vehiculo, id_asesor: "" }
                };
                axios
                    .post("/handler/consignacion/crear_front", { ...data })
                    .then(res => {
                        this.onLoadForm = false;
                        if(res.data.status === 'warning'){
                            this.$swal.fire({
                                icon: 'warning',
                                title: 'Limite de cotizaciones',
                                text: '¡Haz excedido el número de cotizaciones al mes!',
                                confirmButtonColor: '#858796',
                            })
                        }else {
                            document.cookie = "sell_in=" + res.data.consignacion._id;
                            window.location.href = "/vender/response";
                        }
                    });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.form-control {
    background-color: white !important;
    border: 1px solid #e5e5e5;
}
</style>
